import axios, { AxiosRequestConfig } from 'axios';
import { getRootUrl } from '@bingads-webui-react/copilot-utils';

export interface IFetchBillingSummaryProps {
  userId: string;
  customerId: string;
  accountId: string;
}

function getBillingSummary() {
  return `${getRootUrl()}/cc/API/Billing/BillingSummary`;
}

export function fetchBillingSummary({
  accountId,
  customerId,
  userId,
}: IFetchBillingSummaryProps) {
  const url = getBillingSummary();

  return axios.get(url, {
    params: {
      cid: customerId,
      aid: accountId,
      uid: userId,
    },
    headers: {
      'Content-Type': 'application/json',
      'x-requested-with': 'XMLHttpRequest',
    },
    withCredentials: true,
  } as AxiosRequestConfig);
}
